// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__lo761","introBox":"Contact_introBox__8-sUX","introText":"Contact_introText__MQqlt","card":"Contact_card__65bmm","btn":"Contact_btn__pb1T1"};